import { render } from "./QuoteFormSectionCMS.vue?vue&type=template&id=5271f3b0"
import script from "../js/quote-form-section-cms.js?vue&type=script&lang=js"
export * from "../js/quote-form-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__